import { render } from "./klarna-messaging.vue?vue&type=template&id=2b6a58d6"
import script from "./klarna-messaging.vue?vue&type=script&lang=js"
export * from "./klarna-messaging.vue?vue&type=script&lang=js"

import "./klarna-messaging.vue?vue&type=style&index=0&id=2b6a58d6&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__